import {
  InfiniteScroll,
  PlusIcon,
  SearchBar,
  SearchIcon,
  Loading,
} from '@trufla-technology/trumarket-react-design-system';
import './style.scss';
import { useState } from 'react';
import { ListUsers } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import { nameInitials } from 'app/utils';
import { useAssignUserToTeam } from './useAssignUserToTeam.service';

type Props = {
  getUsers: () => void;
  teamKey: string;
  usersAssigned: ListUsers;
};

export const AssignUserToTeam = ({
  usersAssigned,
  teamKey,
  getUsers,
}: Props) => {
  const [unassignedUsers, setUnassignedUsers] = useState<ListUsers>([]);
  const { loadMore, loading, handleAssignUser, debouncedSearch, paging } =
    useAssignUserToTeam(usersAssigned, teamKey, getUsers, setUnassignedUsers);

  return (
    <div className="assign-user-to-team">
      <SearchBar
        placeholder="Search"
        onSearch={(searchValue: string) => {
          debouncedSearch(searchValue);
          setUnassignedUsers([]);
        }}
        icon={<SearchIcon fill="var(--tru-lightgrey)" />}
      />

      {loading && <Loading />}

      <div className="users-list">
        <InfiniteScroll
          data={unassignedUsers}
          hasMore={
            !!!(
              unassignedUsers?.length! + usersAssigned?.length >=
              paging?.count!
            )
          }
          height="100vh"
          itemContent={(index, item) => (
            <button
              key={`data-${index}`}
              type="button"
              onClick={() => {
                if (item?.key) {
                  handleAssignUser(item?.key);
                }
              }}
              className="assign-user-card"
            >
              <div className="user-icon">{nameInitials(item?.fullName)}</div>
              <div className="user-icon-add">
                <PlusIcon fill="var(--tru-white)" width="18px" />
              </div>
              <div className="user-info">
                <h2 className="user-name">{item?.fullName}</h2>
                <p className="user-email">{item?.email}</p>
              </div>
            </button>
          )}
          loadMore={loadMore}
          footer={
            true ? (
              <div className="unassigned-users-loading">
                <Loading />
              </div>
            ) : undefined
          }
          emptyPlaceHolder={
            unassignedUsers?.length === 0 && !loading ? (
              <div className="no-users-found">No Users Found</div>
            ) : null
          }
        />
      </div>
      <br />
    </div>
  );
};
